export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  itemCount: number;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '院线大片、经典佳片、高分电影随时在线观看，支持4K超清画质',
    itemCount: 3280,
    imageQuery: 'Cinematic%20movie%20collage%20with%20film%20reel%20and%20spotlight%2C%20warm%20theater%20ambiance%2C%20artistic%20composition%2C%20soft%20golden%20lighting%2C%20elegant%20minimal%20style'
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热播剧集、经典回顾、全网同步更新，随时随地追剧不停歇',
    itemCount: 2450,
    imageQuery: 'Television%20series%20collage%20modern%20living%20room%20scene%2C%20cozy%20warm%20lighting%2C%20artistic%20minimal%20style%2C%20soft%20ambient%20glow'
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺、搞笑真人秀、音乐竞演，轻松娱乐一网打尽',
    itemCount: 1560,
    imageQuery: 'Variety%20show%20stage%20with%20colorful%20lights%20and%20music%20notes%2C%20vibrant%20warm%20atmosphere%2C%20artistic%20abstract%20style%2C%20soft%20glowing%20effect'
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然探索、历史揭秘、人文纪实，用镜头探索世界的每一个角落',
    itemCount: 980,
    imageQuery: 'Nature%20documentary%20scene%20with%20mountain%20landscape%20and%20camera%20lens%2C%20warm%20earthy%20tones%2C%20artistic%20minimal%20composition%2C%20soft%20natural%20light'
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-smile-line',
    description: '日漫经典、国创佳作、剧场版全收录，二次元世界精彩无限',
    itemCount: 2100,
    imageQuery: 'Anime%20art%20style%20collage%20with%20vibrant%20colors%20and%20creative%20illustration%2C%20warm%20gradient%20background%2C%20artistic%20minimal%20composition%2C%20soft%20lighting'
  },
  {
    slug: 'shaoer',
    name: '少儿',
    icon: 'ri-rocket-line',
    description: '寓教于乐、安全健康，精选优质少儿内容陪伴孩子快乐成长',
    itemCount: 650,
    imageQuery: 'Colorful%20children%20educational%20toys%20and%20books%20arrangement%2C%20warm%20playful%20atmosphere%2C%20soft%20pastel%20colors%2C%20artistic%20minimal%20style%2C%20gentle%20lighting'
  },
];